import { Injector, Pipe, PipeTransform } from '@angular/core';
import { IFormRule, FormElementRegistry, ViewRuleRegistry, IFieldViewRule } from '@farris/devkit';
import { Farris } from '@farris/devkit';

@Pipe({ name: 'elementReadonly' })
export class ElementReadonlyPipe implements PipeTransform {
  constructor(private injector: Injector, private formElementRegistry: FormElementRegistry, private viewRuleRegistry: ViewRuleRegistry) { }
  transform(value: any, elementId: string, version: any) {
    if (!this.formElementRegistry || !this.viewRuleRegistry) {
      return value;
    }
    // è·ååç´ éç½®
    const viewElement = this.formElementRegistry.getElementById(elementId);
    if (!viewElement) {
      return value;
    }
    const binding = viewElement.binding;
    // è·åçé¢è§å
    let viewRule = this.viewRuleRegistry.getRuleById(binding) as IFieldViewRule;
    // åç«¯æªéç½®çé¢è§åæç»ç¶çº§éç½®äºè§å
    if (!viewRule) {
      const isObjectField = binding && binding.indexOf('.') > -1;
      // å¦ææ¯å¯¹è±¡å­æ®µï¼åå°è¯è·åç¶çº§è§å
      if (isObjectField) {
        const parentBinding = binding.substring(0, binding.indexOf('.'));
        viewRule = this.viewRuleRegistry.getRuleById(parentBinding) as IFieldViewRule;
      }
      if (!viewRule) {
        return value;
      }
    }
    // è·åå°äºåç«¯è§å
    const ruleEditable = viewRule.editable;
    if (typeof ruleEditable !== 'boolean') {
      // æ æè§å
      return value;
    }
    const configRule = viewElement.rules.find((rule: IFormRule) => rule.type === Farris.FormRule.RuleType.Readonly);
    // å¦æè§åæ¯å¯ç¼è¾ï¼åæç»åºä¸ºæ¡ä»¶å¯ç¼è¾æå¯ç¼è¾
    if (ruleEditable) {
      if (configRule.dynamic) {
        return value;
      }
      return false;
    }
    return true;
  }
}
